/* @ngInject */

export default (dateTimeService) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function Lender(
    id,
    uuid,
    abbr,
    name,
    type,
    group,
    description,
    turnaround,
    digital,
    integration,
    mbp,
    cps,
    maxBorrow,
    gateway,
    contact,
    isActive
  ) {
    this.id = id;
    this.uuid = uuid;
    this.abbr = abbr;
    this.name = name;
    this.type = type;
    this.group = group;
    this.description = description;
    this.turnaround = turnaround;
    this.digital = digital;
    this.integration = integration;
    this.mbp = mbp;
    this.cps = cps;
    this.maxBorrow = maxBorrow;
    this.gateway = gateway;
    this.contact = contact;
    this.isActive = isActive;
  }

  /*
   * Static Methods
   * --------------------------------------------------------------------------------
   */
  Lender.Blank = function () {
    return Lender.Build({
      id: '',
      uuid: '',
      abbr: '',
      name: '',
      type: [],
      group: '',
      description: '',
      turnaround: 0,
      digital: false,
      integration: {},
      mbp: {},
      cps: {},
      maxBorrow: 0,
      gateway: [],
      contact: [],
      isActive: true
    });
  };

  Lender.Build = function (data) {
    return new Lender(
      data.id,
      data.uuid,
      data.abbr,
      data.name,
      data.type,
      data.group,
      data.description,
      data.turnaround,
      data.digital,
      data.integration,
      data.mbp,
      data.cps,
      data.maxBorrow ? data.maxBorrow : 0,
      data.gateway,
      data.contact,
      data.isActive
    );
  };

  /*
   * Public Methods
   * --------------------------------------------------------------------------------
   */
  Lender.prototype.getName = function () {
    return this.name;
  };
  Lender.prototype.getShorthand = function () {
    return this.abbr;
  };
  Lender.prototype.getMaximumBorrowing = function () {
    return this.maxBorrow;
  };
  Lender.prototype.getBestProductName = function (isInv) {
    return isInv ? this.mbp?.bestProductNameInv || '-' : this.mbp?.bestProductNameOO || '-';
  };
  Lender.prototype.getExpectedRate = function (expRate) {
    const expectedRate = expRate || 0;
    return `${expectedRate.toFixed(2)}%`;
  };
  Lender.prototype.getApplicationPickUpTime = function () {
    return this.turnaround;
  };
  Lender.prototype.getDigitalPlatform = function () {
    return this.digital ? 'Yes' : 'No';
  };
  Lender.prototype.getDate = function () {
    return dateTimeService.getFormattedDate(this.timeStamp);
  };
  Lender.prototype.getTime = function () {
    return dateTimeService.getFormattedTime(this.timeStamp);
  };

  return Lender;
};
